exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1s-tgHHhcz-8rcX-zRr7p0{padding-top:200px;width:100%;height:100%;padding:10px;font-size:12px;color:#fff;text-align:center}", ""]);

// exports
exports.locals = {
	"empty": "_1s-tgHHhcz-8rcX-zRr7p0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./apps/pages/main/layout/css/empty.css
// module id = 1602
// module chunks = 1